import type { ArrayValueType, IAnimateData, ITransformValue } from '@vedalib/editor'
import * as R from 'ramda'
import type React from 'react'

import type { NodeState } from 'services/Store/Project/types'

export const DEFAULT_VALUE: Required<IAnimateData> = {
  opacity: 100,
  x: 0,
  y: 0,
  rotate: 0,
  rotateX: 0,
  rotateY: 0,
  scale: 1,
  scaleX: 1,
  scaleY: 1,
  skewX: 0,
  skewY: 0,
}

export const applyAnimation = (value?: ArrayValueType<IAnimateData>[], isSpring?: boolean) =>
  value?.reduce(
    (acc, item) => {
      R.forEachObjIndexed(
        (value, key) => {
          if (Array.isArray(acc[key])) {
            acc[key].push(value ?? 0)
            if (isSpring && acc[key].length > 2) {
              const init = acc[key][0]
              const end = acc[key][acc[key].length - 1]
              acc[key] = [init, end]
            }
          } else {
            acc[key] = [value ?? 0]
          }
        },
        { ...DEFAULT_VALUE, ...(R.pickBy(R.isNotNil, item.data) as Record<string, number>) },
      )
      return acc
    },
    {} as Record<string, Array<number>>,
  )

export const applyStepStyles = (
  transform?: ITransformValue,
  state?: NodeState['transform'],
): React.CSSProperties => {
  const stepData = transform?.value.find((item) => item.value === state?.step)?.data
  const transforms = [
    { type: 'translate3d', value: `translate3d(${stepData?.x ?? 0}px, ${stepData?.y ?? 0}px, 0)` },
    { type: 'rotate', value: `rotate(${stepData?.rotate ?? 0}deg)` },
    { type: 'rotateX', value: `rotateX(${stepData?.rotateX ?? 0}deg)` },
    { type: 'rotateY', value: `rotateY(${stepData?.rotateY ?? 0}deg)` },
    { type: 'scale', value: `scale(${stepData?.scale ?? 1})` },
    { type: 'scaleX', value: `scaleX(${stepData?.scaleX ?? 1})` },
    { type: 'scaleY', value: `scaleY(${stepData?.scaleY ?? 1})` },
    { type: 'skewX', value: `skewX(${stepData?.skewX ?? 0}deg)` },
    { type: 'skewY', value: `skewY(${stepData?.skewY ?? 0}deg)` },
  ]

  return {
    transformOrigin: transform?.transformOrigin,
    opacity: stepData?.opacity === 0 ? 0.1 : (stepData?.opacity ?? 1),
    transform: transforms.map((t) => t.value).join(' '),

    // fix outer indents
    margin: 0,
    // fix in absolute
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  }
}
